<template>
  <div class="project-page">
    <ProjectHero :project="project" />
    <FeatureGrid :features="project.features" :color="project.color" subtitle="自动组包、手动组包、同步异步、流式收发，覆盖串口通信全场景" />

    <!-- 应用场景 -->
    <section class="section scenario-section">
      <div class="container">
        <div data-aos="fade-up">
          <span class="section-eyebrow">USE CASES</span>
          <h2 class="section-title">实测应用场景</h2>
          <p class="section-subtitle">多次长时间测试，覆盖工业、商业、安防等串口设备</p>
        </div>
        <div class="scen-grid">
          <div
            v-for="(s, i) in project.scenarios"
            :key="s.name"
            class="scen-card"
            data-aos="fade-up"
            :data-aos-delay="(i % 4) * 60"
          >
            <div class="scen-icon"><i :class="s.icon"></i></div>
            <div>
              <h3 class="scen-name">{{ s.name }}</h3>
              <p class="scen-desc">{{ s.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <CodeSection
      :code-blocks="project.codeBlocks"
      :gradle-block="project.gradleBlock"
      :maven-block="project.mavenBlock"
      :proguard-block="project.proguardBlock"
      subtitle="基础用法、Java 同步/异步、Kotlin 用法、协议头组包完整示例"
    />

    <section class="section" style="padding-top:0">
      <div class="container">
        <div class="proj-cta-box" data-aos="fade-up">
          <div>
            <h3 class="proj-cta-title">USB 转串口？看这里</h3>
            <p class="proj-cta-desc">如果是 USB 转串口，请参考 CH340/CH341 免驱应用库 CH34xUART。</p>
          </div>
          <a href="https://github.com/yutils/CH34xUART" target="_blank" rel="noopener" class="btn btn-primary">
            <i class="fa-brands fa-github"></i> CH34xUART
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { projects } from '@/data/projects.js'
import ProjectHero from '@/components/ProjectHero.vue'
import FeatureGrid from '@/components/FeatureGrid.vue'
import CodeSection from '@/components/CodeSection.vue'

const project = projects.yserialport
</script>

<style scoped>
.scenario-section { border-top: 1px solid var(--border-soft); }
.scen-grid {
  margin-top: 56px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}
.scen-card {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  padding: 20px 18px;
  transition: all 0.25s ease;
}
.scen-card:hover {
  border-color: var(--border);
  transform: translateY(-3px);
}
.scen-icon {
  flex-shrink: 0;
  width: 40px; height: 40px;
  display: grid; place-items: center;
  border-radius: 10px;
  background: var(--accent-soft);
  color: var(--accent);
  font-size: 1rem;
}
.scen-name {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 4px;
}
.scen-desc { color: var(--text-muted); font-size: 0.82rem; }

.proj-cta-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: 16px;
  padding: 36px 40px;
}
.proj-cta-title { font-family: var(--font-display); font-weight: 600; font-size: 1.5rem; margin-bottom: 6px; }
.proj-cta-desc { color: var(--text-muted); }

@media (max-width: 1024px) { .scen-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 600px) { .scen-grid { grid-template-columns: 1fr; } }
</style>
